import { useI18n } from '@i18n/useI18n';
import {GridWrapper} from '@components/GridCards/Common.styled';
import {useStore} from '@store/appStore';
import {useEffect, useState} from 'react';
import CourseStats from './CourseStats';
import {CustomGrid} from './Course.styled';
import CourseStudentList from './CourseStudentList';
import toTitleCase from '@utils/textTools';


interface IProps {
    students:any,
    pin?: (id, pin) => any,
    teacher?: boolean,
    click?: (id, name, studentID) => any,
    course?:any,
    pinnedCourses?:any,
    pinnedStudents?:any,
    pinStudent?: (id, pin) => any
    schoolLeader?: boolean
}


export const Course = (props: IProps, ref) => {
  const { settings, callNameSetting } = useStore();
  const [load, setLoad] = useState(false)
  const i18n = useI18n();

  useEffect(() => {
      setLoad(!load)
  }, [props.course.days])

  return (
    <GridWrapper>
      <CourseStudentList schoolLeader={props.schoolLeader} click={props.click} teacher={props.teacher} title={toTitleCase(i18n.t(callNameSetting + "-s"))} content={props.students} extraButtons={props.schoolLeader?false:true} pinnedStudents={props.pinnedStudents} pinStudent={props.pinStudent} />
      <CustomGrid>
        <CourseStats course={props.course} teacher={props.teacher} pin={props.pin} pinnedCourses={props.pinnedCourses} />
      </CustomGrid>
    </GridWrapper>
  );
};

export default Course;
